<template>
    <div class="thanks-props-block">
<!--        <h5 class="thanks-props-block__title">-->
<!--            <slot name="title" />-->
<!--        </h5>-->
        <div class="thanks-props-block__items">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ThanksPropsBlock'
}
</script>

<style lang="scss" scoped>
.thanks-props-block{
    //&__title{
    //    font-size: 14px;
    //    color: #757575;
    //    @include point-md{
    //        font-size: 16px;
    //    }
    //}
    &__items{
        display: grid;
        grid-row-gap: 16px;
        :deep(> div){
            display: grid;
            grid-template-columns: 1fr;
            grid-row-gap: 4px;
            @include point-md{
                grid-template-columns: repeat(2, 1fr);
            }
        }
        :deep(p:first-child){
            color: #757575;
        }
        :deep(p){
            font-size: 14px;
            @include point-md{
                font-size: 16px;
            }
        }
    }
}
</style>